<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import PlaylistsGridBlock from '@components/playlists/playlists-grid-block'

const featuredPlaylists = ref([])

onMounted(() => {
    DataLayer.playlists.getByType({ type: 'editorial', featured: 1 }).then(response => {
        featuredPlaylists.value = response.body.filter(playlist => playlist.revisions_id !== null)
    })
})
</script>

<template>
    <div v-if="featuredPlaylists && featuredPlaylists.length" >
        <BaseSection title="Featured Playlists">
            <PlaylistsGridBlock
                :playlists="featuredPlaylists"
                type="playlists"
                min-tile-width="160px"
            />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

</style>
